import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonBookingService } from '../shared/common-booking.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationIntervalService } from 'src/app/shared/services/notification.interval.service';
import {  Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { phoneValidator } from 'src/app/shared/validators/phone-validator';
import { FormConstants } from '../../core/globals/form-constants';
import { BookingsViewService } from './bookings-view.service';
import { DrawerService } from 'mis-crystal-design-system/drawer';
import { BookingSingleDetailsComponent } from './booking-single-details/booking-single-details.component';
import { BookingActionsHeaderService } from '../shared/booking-actions-header/booking-actions-header.service';
import { DownloadAsCsvService } from '../../shared/services/download-as-csv.service';
import { CommonBillingService } from '../../billing/shared/common-billing.service';
import { parseZone } from 'moment';
import { CreateBookingService } from '../create-booking/create-booking.service';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';


@Component({
  selector: 'app-bookings-view',
  templateUrl: './bookings-view.component.html',
  styleUrls: ['./bookings-view.component.scss']
})
export class BookingsViewComponent implements OnInit, OnDestroy {

  constructor(private commonService: CommonService,
              private utilService: UtilService,
              private router: Router,
              private authService: AuthService,
              private commonBookingService: CommonBookingService,
              private notificationService: NotificationIntervalService,
              private cdr: ChangeDetectorRef,
              private bookingViewService: BookingsViewService,
              private drawerSvc: DrawerService,
              private bookingActionsHeaderService: BookingActionsHeaderService,
              private downloadAsCsvService: DownloadAsCsvService,
              private commonBillingService: CommonBillingService,
              private createBookingService: CreateBookingService
  ) {
    this.state = this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : null;
    if (this.router.url !== '/bookings-view' && !this.state) {
      this.router.navigate(['/bookings-view']);
    }
  }
  private rejectPostData: any;
  public bookingDetails: any = [];
  public searchInput: any;
  public searchBookings: any;
  public searchTimer: any;
  public selectedBookings = [];
  public selectedBookingDetailed = [];
  public vendors: any[] = [];
  public selectedVendor: any;
  public totalNoOfTrips = 0;
  public tripsWithNoVendors = 0;
  public tripsWithNoCabs = 0;
  public cancelledTrips = 0;
  public marshallNotAssigned = 0;
  public allBookingsSelected = false;
  public showCheckboxHyphen = false;
  public isLoading = false;
  isSpinning = false;
  public bookingHistoryUnformatted: any;
  public showHistoryView = false;
  public editCutOffDetails: any;
  public canEdit = false;
  public canCancel = false;
  public showEditBookingError = false;
  public cancelCutOffDetails: any;
  public showCancelConfirmDialog = false;
  public cancelBookingInfo: any;
  public updateBookingError = false;
  public config: any;
  public cabs: any = [];
  public offices: any;
  public selectedCab: any;
  public bookingHistoryId: any;
  public updateBookingErrorMessage: any;
  public globalError = 'Failed Update';
  public startDate: any;
  public endDate: any;
  public startDate1: any;
  public endDate1: any;
  public dateMaxConfig: any;
  public inputControlStartDate: any;
  public inputControlEndDate: any;
  public formDetails: FormGroup;
  public bookingFilterConfig: any;
  public sortAscending = true;
  public officeOptions: any;
  public bookingTypeConfig: any;
  public cityConfig: any;
  public officeConfig: any;
  public vendorCabStatusConfig: any;
  public marshallStatusConfig: any;
  public bookingActionConfig: any;
  public bookingActionsConfigObj = {};
  public vendorSelectConfig: any;
  public cabTypeConfig: any;
  public bookingTimer: any;
  public now = 0;
  public lastUpdateInterval: any;
  public isAutoReload: boolean;
  public showHeader = true;
  public tabularConfig: any;
  public tabularConfigObj: any = new Map();
  public disableActionsConfig: any;
  public showUpdateSuccess = false;
  public vendorCabSelectFormGroup = new FormGroup({});
  driverForm = {};
  public virtualCabForm: any = new FormGroup({});
  public vendorSelectConfigObj: any;
  public vendorCabMap = {};
  public cabDriverMap = {};
  public bookingActionBtnConfig: any;
  public bookingActionBtnConfigObj: any;
  public failedBookings = [];
  public showBookingDetails = false;
  public showRequestDetails = false;
  public singleBookingDetails: any;
  public singleRequestDetails: any;
  public cabAllocationConfig: any;
  public cabAllocationConfigObj: any;
  public isAddCabFormVisible = false;
  public addCabForBooking: any;
  public successMessage: string;
  public globalSuccess = "Booking(s) updated successfully";
  public displayInvalidDateError = false;
  public requestRaised: string;

  public sendComm = false;

  public assignVendor = false;
  singleReg: any;

  formConstants = FormConstants;
  isRejectActionSelected = false;
  isSubmitReasonClicked = false;
  reasonText: string;
  cancelPopUpConfig: any;
  rejectDenyPopupConfig: any;
  maxLimit = 200;
  private destroy$ = new Subject();
  summaryData: any = {};
  totalPages = 0;
  currentPage = 0;
  pageSize = 20;
  state: { [k: string]: any; };
  eligibleBookings = [];
  nonEligibleBookings = [];
  showApproveModalTM = false;
  showAcceptModalVM = false;
  showDenyModalVM = false;
  showDenyReasonBlock = false;
  showRejectReasonBlock = false;
  showModal = false;
  postDataForApprovaAndAccept = [];
  showVirtualCab: boolean;
  miscelleneousConfig;
  multiDriverFeature = false;
  virtualCabFeature = false;
  isIndianCountry = false;
  driverList = [];
  virtualCabBooking: any;
  virtualCabDriverDetails = {};
  showDialog: boolean;
  cabForselectedDriver: any;
  noDriverOrCab: any;
  selectedVirualCabBooking: any;
  subject$ = new Subject();
  cabRankMap: any;
   dateObj: any;
  range = 7;


  // dataSource !: MatTableDataSource<any>

  triggerAssign = false;
  expandedElement: any | null;
  isShowing = false;
  hasDimmBack = false;
  selectedReg: any;
  totalNoOfRows = 0;
  dataSource: any;

  displayedColumns: string[] = ['check', 'bookid', 'tripDate', 'tripID', 'time', 'rider', 'startAddress', 'end', 'bookType', 'cabType', 'vendor', 'cab', 'driver', 'status', 'actions'];

  count = 10;
  tableSize = 1;
  tableSizes: any = [1, 3, 6, 9, 12, 20];
  p = 1;
  pageIndex = 0;
  openAssignDroper = false;
  public downloadReportFailed: string;

  pageIndexNew = 1;

  paginationId = 'booking-view-pagination';

  JSON = JSON;
  unsortedData: any;
generateBillingAccess: boolean;
  rangeDate: number[];
  selectedDates: any;
  // openAssignModel:boolean=false
  virtualDriver = false;
  reports: DropdownItem[] = [
    {
      label: 'Sign-In Report',
      value: 'Sign-In Report'
    },
    {
      label: 'Booking Report',
      value: 'Booking Report'
    },
    {
      label: 'Billing Report',
      value: 'Billing Report'
    },
  ];
  showToast = false;
  toastMsg = '';
  marshalAssigned = false;

  searchTimeout;
  tabularConfigKeys : any = [];
  columnMap = {
    'masterBookingID': 'masterBookingId',
    'Trip Date': 'displayDate',
    'Trip ID': 'tripID',
    'Time': 'displayTime',
    'Start': 'tripSource',
    'End': 'tripDestination'
  };
  commentsIcon='assets/comments-icon.svg'
  mergeBookingIcon='assets/merge-booking.svg'
  documentIcon='assets/docAttached.svg'
  marshallAssignedIcon='assets/Marshall Status-Assigned.svg'
  marshallRequestedIcon='assets/Marshall Status-Pending.svg'
  isSameDateRange: boolean = false; 

  ngOnInit() {
    this.createBookingService.showCreateBookingButton.next(true);
    this.notificationService.filteredCreateBookingListObs.
      pipe(
        takeUntil(this.destroy$)
      ).
      subscribe((response) => {
        if (this.router.url === '/bookings-filtered-view') {
          this.getFilteredBooking(response);
        }
      });
    this.notificationService.filteredVendorAcceptanceListObs.
      pipe(
        takeUntil(this.destroy$)
        ).
        subscribe((response) => {
        if (this.router.url === '/bookings-filtered-vendor-view') {
          this.getFilteredBooking(response);

        }
      });

    this.notificationService.filteredCabAllocationListObs.
      pipe(
        takeUntil(this.destroy$)
      ).
      subscribe((response) => {
        if (this.router.url === '/bookings-filtered-cab-view') {
          this.getFilteredBooking(response);

        }
      });
    this.formDetails = new FormGroup({
      bookingType: new FormControl('', [Validators.required]),
      city: new FormControl('', Validators.required),
      office: new FormControl('', [Validators.required]),
      vendorCabStatus: new FormControl('', [Validators.required]),
      cabTypes: new FormControl([], Validators.required),
      timeRange: new FormControl({startTime: '00:00', endTime: '23:59'}, Validators.required),
      // marshallStatus:new FormControl('',[Validators.required])
    });
    this.getConfigs();
    this.bookingViewService.cabRankMap.pipe(
      takeUntil(this.destroy$))
      .subscribe((res) => {
        this.cabRankMap = res;
      });

      // new
    this.createBookingService.fetchEscortConfig().subscribe(res => {
        this.createBookingService.preponeTripSheetInHours.next(res[0].preponeTripSheetInHours);
        this.createBookingService.startTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.startTime);
        this.createBookingService.endTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.endTime);
      });

      if(this.miscelleneousConfig?.newBillingReport)
      this.reports.push({
        label: 'New Billing Report',
        value: 'New Billing Report'
    })
  }
  getSelectedReg(data: any) {
    this.selectedReg = data;
  }
  closeBackground() {
    this.hasDimmBack = false;
  }
  makeDimm() {
    this.hasDimmBack = true;
  }
  openDrawer(booking: any) {
    const drawerRef = this.drawerSvc.show(
      BookingSingleDetailsComponent,
      { data: booking,
        miscelleneousConfig: this.miscelleneousConfig,
        showOtpProperty :  this.commonService.workflowConfig['showOTPOnDashboard'] },
      { width: "422px" }
    );
    drawerRef.afterClosed.subscribe();

  }

  toggleSidenav(data, type) {

    // this.isBackdrop = true;


    this.isShowing = data == 'close' ? !this.isShowing : true;
    if (type == 'table') {
      // this.selectedData = data;
    }


    if (data == 'close') {
      // this.clearSeletedData()
      // this.isBackdrop = false;
    }
  }
  getIdentifier(index, item) {
    return index;
  }

  getConfigIdentifier(index, item) {
    return item.elementKey;
  }

  openVirtualCabPopUp(value, booking) {
    this.selectBookingOnVendorCabAssign(booking);
    let drivername;
    let contactNumber;
    let registration;
    if (booking.cab && booking.cab.virtual && booking.cab.driver) {
      drivername = booking.cab.driver.name;
      contactNumber = booking.cab.driver.phoneNumbers[0];
      registration = booking.cab.registration;
    }
    this.virtualCabBooking = booking;
    const indianRegistrationRegex = new RegExp(/[A-Za-z0-9]{4,}[0-9]{4}/);
    let registrationNoValidator;
    if (this.isIndianCountry) {
      registrationNoValidator = [Validators.required, Validators.pattern(indianRegistrationRegex)];
    }
    else {
      registrationNoValidator = Validators.required;
    }
    this.virtualCabForm = new FormGroup({
      driverName: new FormControl(drivername || '', Validators.required),
      driverContact: new FormControl(contactNumber || '', [Validators.required, phoneValidator]),
      registrationNo: new FormControl(registration || '', registrationNoValidator),
    });
    if (drivername && registration) {
      const driverName = this.virtualCabForm.get('driverName');
      driverName.disable();
      const driverContact = this.virtualCabForm.get('driverContact');
      driverContact.disable();
    }
    this.showVirtualCab = true;
    this.selectedVirualCabBooking = booking.bookingId;
    this.toggleAutoReload(value);

  }

  closeVirtualPopup() {
    this.showVirtualCab = false;
    this.toggleAutoReload(false);
    this.vendorCabSelectFormGroup.get(this.selectedBookings).get('cab').setValue('');
    this.selectedBookingDetailed = [];
    this.selectedBookings = [];
    this.handleMarkHeaderCheckbox();
  }

  getConfigs() {
    this.isLoading = true;
    this.commonService.fetchMiscConfig().subscribe((response: any) => {
      this.miscelleneousConfig = response;
      if (response && response['pageSize']) {
        this.pageSize = parseInt(response['pageSize']);
        this.ceilingPageSize();
      }
    });
    if (!this.commonService.workflowConfig) {
      this.commonService.fetchWorkflowConfig().subscribe((response: any) => {
        this.commonService.workflowConfig = response;
        this.generateBillingAccess = response.billingReportAccess;
        this.getVendorsAndCabsList();
      }, error => {console.error();
      });
    } else {
      this.getVendorsAndCabsList();
    }
    this.isLoading = true;
    this.commonService.fetchConfig().subscribe((response: any) => {
            this.multiDriverFeature = response['etsMultiDriverEnable'];
            this.virtualCabFeature = response['etsVirtualCabEnable'];
            this.isIndianCountry = (response['etsCountry'] === 'INDIA');
            this.config = this.commonService.getConfigForElementKey(response, 'Booking View Page');
            this.bookingFilterConfig = this.commonService.getConfigForElementKey(this.config, 'Filter Section');
            this.authService.getServerTime({ buid: this.authService.user.buId }).subscribe((res) => {
        this.authService.serverTime = res;
        this.setDateFilters();
        this.setFilterDefaults();
        this.getBookingActionConfig();
        this.setCabAllocConfigs();
        this.setTabularConfigs();
        this.setReasonConfig(response);
        this.setVendorAssignConfig();
        this.getRequiredDataForBookings();
      });
    });
  }

  setReasonConfig(config: any) {
    const reasonConfigSection = this.commonService.getConfigForElementKey(config, 'Booking Action Popup');
    this.cancelPopUpConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Cancel Booking');
    if (this.authService.user.role === "TRANSPORT_MANAGER") {
      this.rejectDenyPopupConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Reject Booking').elementConfigList[0];
    } else if (this.authService.user.role === "VENDOR_MANAGER") {
      this.rejectDenyPopupConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Deny Booking').elementConfigList[0];
    }
  }

  getRequiredDataForBookings() {
    this.commonBookingService.getAdditionalDataForBookings().subscribe(responseList => {
      this.editCutOffDetails = responseList[0];
      this.cancelCutOffDetails = responseList[1];
      this.disableActionsConfig = responseList[2];
      this.getBookingDetails();
      this.getBookingsSummaryData();
    });
  }

  setFilterDefaults() {
    if (this.bookingFilterConfig && this.formDetails) {
      this.bookingTypeConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'Booking Type');
      this.cityConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'City');
      this.officeConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'Offices');
      this.vendorCabStatusConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'VendorCabStatus');
      // this.marshallStatusConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'MarshallStatus');
      this.cabTypeConfig = this.commonService.getConfigForElementKey(this.bookingFilterConfig, 'cabType');

      this.formDetails.get('bookingType').setValue(this.bookingTypeConfig.config.defaultValue);
      this.formDetails.get('city').setValue(this.cityConfig.config.defaultValue);
      if (this.officeConfig.config.visibility.visible) {
        this.formDetails.get('office').setValue(this.officeConfig.config.defaultValue);
      }
      this.formDetails.get('vendorCabStatus').setValue(this.vendorCabStatusConfig.config.defaultValue);
      // this.formDetails.get('marshallStatus').setValue(this.marshallStatusConfig.config.defaultValue);
      if(this.cabTypeConfig?.config?.defaultValue){
        this.formDetails.get('cabTypes')?.setValue(this.cabTypeConfig.config.defaultValue);
      }
      this.cdr.detectChanges();
      this.commonService.cities.next(this.cityConfig);
    }
  }

  setDateFilters() {
    const dateConfigUtils = this.commonService.getConfigForElementKey(this.config, 'Filter Section');

    const startDateConfig = this.commonService.getConfigForElementKey(dateConfigUtils, 'Start Date').config.defaultValue;
    const endDateConfig = this.commonService.getConfigForElementKey(dateConfigUtils, 'End Date').config.defaultValue;

    this.startDate = this.utilService.getMoment().add(Number(startDateConfig), 'days');
    this.endDate = this.utilService.getMoment().add(Number(endDateConfig), 'days');
    this.inputControlStartDate = new FormControl([this.startDate]);
    this.inputControlEndDate = new FormControl([this.endDate]);

    this.dateMaxConfig = {
      startDate: this.startDate,
      endDate: this.endDate,
    };

    // check if startDate, endDate are same
    this.isSameDateRange = this.startDate.isSame(this.endDate);
  }

  pageChanged(event) {
    this.currentPage = (event - 1);
    this.getBookingDetails();
  }

  getBookingsSummaryData() {
    const startDateWTime = this.startDate.format('DD-MM-YYYY') + ' ' + this.formDetails.get('timeRange').value?.startTime;
    const endDateWTime = this.endDate.format('DD-MM-YYYY') + ' ' + this.formDetails.get('timeRange').value?.endTime;

    const body = {
      bookingType: this.formDetails.get('bookingType').value || null,
      buid: this.authService.user.buId,
      city: this.formDetails.get('city').value,
      endDate: endDateWTime,
      startDate: startDateWTime,
      status: this.formDetails.get('vendorCabStatus').value,
      // marshallStatus: this.formDetails.get('marshallStatus').value,
      offices: this.formDetails.get('office').value || null,
      vendor: (this.authService.isUserVendor() ? true : false),
      cabTypes: this.formDetails.get('cabTypes')?.value || [],
    };
    if (this.authService.isUserVendor()) {
      body['employeeGuid'] = this.authService.user.employeeGuid;
    }
    else {
      body['employeeGuid'] = '';
    }
    this.isLoading = true;
    this.commonBookingService.fetchBookingSummaryData(body).subscribe((response) => {
      this.summaryData = response;
    }, (error) => {
      this.isLoading = false;
    });

  }

  resetPagination() {
    this.currentPage = 0;
    this.totalPages = 0;
    this.selectedBookings = [];
    this.selectedBookingDetailed = [];
    this.showCheckboxHyphen = false;
  }

  getBookingDetails() {
    if(!this.startDate || !this.endDate){
      this.startDate = parseZone();
      this.endDate = parseZone();
    }
    const startDateWTime = this.startDate.format('DD-MM-YYYY') + ' ' + this.formDetails.get('timeRange').value?.startTime;
    const endDateWTime = this.endDate.format('DD-MM-YYYY') + ' ' + this.formDetails.get('timeRange').value?.endTime;
    
    const body = {
      startDate: startDateWTime,
      endDate: endDateWTime,
      // startDate: '26-04-2022',
      // endDate: '29-04-2022',
      buid: this.authService.user.buId,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      myBookings: false,
      bookingType: this.formDetails.get('bookingType').value || null,
      offices: this.formDetails.get('office').value || null,
      city: this.formDetails.get('city').value,
      status: this.formDetails.get('vendorCabStatus').value,
      // marshalStatus:this.formDetails.get('marshallStatus').value,
      vendor: (this.authService.isUserVendor() ? true : false),
      cabTypes: this.formDetails.get('cabTypes')?.value || [],
    };
    if (this.authService.isUserVendor()) {
      body['employeeGuid'] = this.authService.user.employeeGuid;
    }
    else {
      body['employeeGuid'] = '';
    }
    const queryString = {
      searchText: this.searchInput ? this.searchInput:""
    };
    if (this.bookingTimer) {
      clearTimeout(this.bookingTimer);
    }
    if (!this.isAutoReload) {
      this.isLoading = true;
      this.allBookingsSelected = false;
    }
    // incase of normal booking view page loading
    if (!this.state) {
      this.commonBookingService.fetchBookings(queryString, body).subscribe((response) => {

        clearInterval(this.lastUpdateInterval);

        this.now = 0;
        this.bookingDetails = response['spotBookingDTO'];
        // this.filterBookings
        this.totalNoOfRows = this.bookingDetails.length;
        this.totalPages = response['paginationCount'];
        if (!this.isAutoReload) {
          this.bookingDetails = response['spotBookingDTO'];
          this.inputControlEndDate.markAsPristine();
          this.inputControlStartDate.markAsPristine();
        }
        this.setBookingAdditionalInfo();
        this.sortBookings(this.sortAscending);
        this.setVendorAndCabFormControl();
        this.setDriverFormControl();
        if (!this.isAutoReload) {
          this.isLoading = false;
        }


        if (this.isAutoReload) {
          // change selectedBookingsInfoUpdated to a public variable and pass to child component to get updated info in a new array.
          const selectedBookingsInfoUpdated = this.bookingDetails.filter((booking) => {
            let index = this.selectedBookings.indexOf(booking.bookingId);
            if (index >= 0 && booking.bookingStatus === 'CANCELLED') {
              this.selectedBookings.splice(index, 1);
              index = -1;
            }
            return index > -1 ? true : false;
          });
          this.selectedBookingDetailed = selectedBookingsInfoUpdated;
        }
        if (this.isAutoReload && this.allBookingsSelected && this.selectedBookings.length < this.bookingDetails.length) {
          this.allBookingsSelected = false;
          this.showCheckboxHyphen = true;
        }
        this.isAutoReload = false;
        this.lastUpdateInterval = setInterval(() => {
          this.now += 10;
        }, 10000);
        this.bookingTimer = setTimeout(() => {
          this.isAutoReload = true;
          this.searchInput = "";
          this.getBookingDetails();
        }, 120000); // 120000
      }, (error) => {
        this.isLoading = false;
      });
    } else {
      this.getFilteredBooking(this.state.bookingsList);
    }
  }

  getFilteredBooking(bookingList) {
    this.commonBookingService.fetchBookingByBookingList(bookingList).
      pipe(
        takeUntil(this.destroy$)
      ).
      subscribe((response) => {

        clearInterval(this.lastUpdateInterval);
        // this.now = 0;
        this.bookingDetails = response;
        this.totalPages = response['paginationCount'];
        this.isLoading = false;
        // if (!this.isAutoReload) {
        //   this.bookingDetails = response;
        //   this.inputControlEndDate.markAsPristine();
        //   this.inputControlStartDate.markAsPristine();
        // }
        this.setBookingAdditionalInfo();
        this.sortBookings(this.sortAscending);
        this.setVendorAndCabFormControl();
        this.setDriverFormControl();
        // if (!this.isAutoReload) {
        //   this.isLoading = false;
        // }
        if (this.isAutoReload) {
          // change selectedBookingsInfoUpdated to a public variable and pass to child component to get updated info in a new array.
          const selectedBookingsInfoUpdated = this.bookingDetails.filter((booking) => {
            let index = this.selectedBookings.indexOf(booking.bookingId);
            if (index >= 0 && booking.bookingStatus === 'CANCELLED') {
              this.selectedBookings.splice(index, 1);
              index = -1;
            }
            return index > -1 ? true : false;
          });
          this.selectedBookingDetailed = selectedBookingsInfoUpdated;
        }

        if (this.isAutoReload && this.allBookingsSelected && this.selectedBookings.length < this.bookingDetails.length) {
          this.allBookingsSelected = false;
          this.showCheckboxHyphen = true;
        }

        // this.isAutoReload = false;
        // this.lastUpdateInterval = setInterval(() => {
        //   this.now += 10;
        // }, 10000);
        // auto reload
        // this.bookingTimer = setTimeout(() => {
        //   this.isAutoReload = true;
        //   this.searchInput = "";
        //   this.getBookingDetails();
        // }, 120000); // 120000
      }, (error) => {
        this.isLoading = false;
      });
  }

  filterBookings(data: any, searched: boolean) {
    let filteredBookings = [];
    const bookingType = this.formDetails.get('bookingType').value;
    const city = this.formDetails.get('city').value;
    const office = this.formDetails.get('office').value;
    const vendorCabStatus = this.formDetails.get('vendorCabStatus').value;
    // const marshallStatus=this.formDetails.get('marshallStatus').value
    if (bookingType === 'All' && city === 'All' && office === 'All' && vendorCabStatus === 'All' ) {
      filteredBookings = data;
    } else {
      for (const booking of data) {
        let isBookingMatch = true;
        if (bookingType && bookingType !== 'All' && booking.spotBookingType !== bookingType) {
          isBookingMatch = false;
        } else if (city && city !== 'All' && booking.city !== city) {
          isBookingMatch = false;
        } else if (office && office !== 'All' && !booking.office) {
          isBookingMatch = false;
        } else if (office && office !== 'All' && booking.office && booking.office.address !== office) {
          isBookingMatch = false;
        } else if (vendorCabStatus && vendorCabStatus !== 'All') {
          if (vendorCabStatus === 'Vendor Assigned' && !booking.vendor) {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Vendor Not Assigned' && booking.vendor) {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Cab Allocated' && !booking.cab) {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Cab Not Allocated' && booking.cab) {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Cancelled' && booking.bookingStatus !== "CANCELLED") {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Approved' && booking.managerStatus !== "APPROVED") {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Pending' && booking.managerStatus !== "PENDING") {
            isBookingMatch = false;
          } else if (vendorCabStatus === 'Rejected' && booking.managerStatus !== "REJECTED") {
            isBookingMatch = false;
          }
        }
        if (isBookingMatch) {
          filteredBookings.push(booking);
        }
      }
    }
    /*if (this.searchInput && !searched) {
      this.onBookingsSearch(filteredBookings);
    } else {
      this.searchBookings = filteredBookings;
    }*/
    // this.setTripSummaryValues();
  }

  setBookingAdditionalInfo() {
    for (const booking of this.bookingDetails) {
      const riderMap = {};
      if (booking && booking.stops){
        for (const stop of booking.stops) {
          stop.riders.forEach((rider) => {
            if (!riderMap[rider.personId]) {
              riderMap[rider.personId] = rider.name;
            }
          });
          if (stop.priorityOrder === '1') {
            booking['tripSource'] = stop.address;
            continue;
          }
          if (stop.priorityOrder === booking.stops.length.toString() && booking.stops.length > 1) {
            booking['tripDestination'] = stop.address;
            continue;
          }
        }
      }
      const riderNamesArray: string[] = Object.values(riderMap);
      let riderNames = "";
      riderNamesArray.forEach((rider, index) => {
        if (index !== riderNamesArray.length - 1) {
          riderNames += rider + ", ";
        } else {
          riderNames += rider + "";
        }
      });
      booking["riderNames"] = riderNames;
      booking['isCancelDisabled'] = !this.commonBookingService.isBookingCancelDisabled(booking, this.cancelCutOffDetails);
      booking['isEditDisabled'] = !this.commonBookingService.isBookingEditDisabled(booking, this.editCutOffDetails);
      booking['displayDate'] = this.getBookingDate(booking);
      booking['displayTime'] = this.getBookingTime(booking);

      // set actions disabled
      if(this.disableActionsConfig && Array.isArray(this.disableActionsConfig)){
        for (const disableAction of this.disableActionsConfig) {
          let disableActionForBooking = false;
          for (const actionStatus of disableAction.Disable) {
            const bookingStatus = booking[actionStatus.Status];
            const index = actionStatus.Values.indexOf(bookingStatus);
            if (index >= 0) {
              disableActionForBooking = true;
              break;
            }
          }
          booking[disableAction.Action + '-disable'] = disableActionForBooking ? true : false;
        }
      }
    }
  }

  getRiderDertails(stops) {
    const riders = [];
    const riderSet = new Set();

    stops?.forEach(stop => {
      stop.riders.forEach(rider => {
        const riderIdentifier = rider.personId;
        if (!riderSet.has(riderIdentifier)) {
          riders.push({
            name: rider.name,
            gender: rider.gender,
            department: rider.department
          });
          riderSet.add(riderIdentifier);
        }
      });
    });
    return riders;
  }

  femaleRiderPresent(stops) {
    const stopsWithFemaleRiders = stops.filter(stop =>
      stop.riders.some(rider => rider.gender === 'Female')
    );
    return stopsWithFemaleRiders.length > 0 ? true : false;
  }

  getCount(stops) {
    const riderCount = stops.reduce((count, stop) => {
      return count + stop.riders.reduce((innerCount, rider) => {
        return innerCount + (rider.boardingType === 'PickUp' ? 1 : 0);
      }, 0);
    }, 0);
    return riderCount - 1 > 0 ? `+${riderCount - 1}` : ``;
  }

  setDriverFormControl() {

    if (this.bookingDetails && this.bookingDetails.length) {
      for (const booking of this.bookingDetails) {
        const driverDetails = booking.cab && booking.cab.driver;
        const cabAndVendorGroup = new FormGroup({
          driver: new FormControl(driverDetails && driverDetails.guid
            || this.driverForm[booking.bookingId] &&
            this.driverForm[booking.bookingId].driver && this.driverForm[booking.bookingId].get('driver').value),
          driverOption: new FormControl(this.miscelleneousConfig['showAllDriverList'] === 'false' && driverDetails ?
            this.getDependentDriverList(booking.cab.guId) : null),
          deviceId: new FormControl(null)
        });
        /// to do above
        // driver set in case of driver saved already
        // same for driver options if cab is already there , also depend on multidriver feauture enabled and enabled for which option
        this.driverForm[booking.bookingId] = cabAndVendorGroup;
      }
    }
  }

  getDependentDriverList(cabguid) {
    if (this.cabs) {
      const matchedCab = this.cabs.find((cab) => cab.guId === cabguid);
      return matchedCab ? matchedCab.drivers : '';
    }
  }

  setVendorAndCabFormControl() {
    for (const booking of this.bookingDetails) {
      let skipBooking = false;
      let cabAndVendorGroup;
      if (this.selectedBookings.length) {
        const index = this.selectedBookings.indexOf(booking.bookingId);
        if (index > -1) {
          skipBooking = true;
          const formData = this.vendorCabSelectFormGroup.get(booking.bookingId);
          cabAndVendorGroup = new FormGroup({
            vendor: new FormControl(formData.get('vendor').value || null),
            cab: new FormControl(formData.get('cab').value || null),
            cabOptions: new FormControl(formData.get('cabOptions').value)
          });
          break;
        }
      }

      if (!skipBooking) {
        let cabOptions = [];
        if (booking.vendor) {
          cabOptions = this.vendorCabMap[booking.vendor.guid];
        } else {
          cabOptions = this.cabs;
        }
        // cab: new FormControl(booking.cab ? booking.cab.virtual ? booking.cab.registration : booking.cab.guId : null),
        // for showing actual virtual cab number in the dropdown
        cabAndVendorGroup = new FormGroup({
          vendor: new FormControl(booking.vendor ? booking.vendor.guid : null),
          cab: new FormControl(booking.cab ? booking.cab.virtual ? booking.cab.registration : booking.cab.guId : null),
          cabOptions: new FormControl(cabOptions)
        });
      }

      if (this.vendorCabSelectFormGroup.get(booking.bookingId)) {
        this.vendorCabSelectFormGroup.setControl(booking.bookingId, cabAndVendorGroup);
      } else {
        this.vendorCabSelectFormGroup.addControl(booking.bookingId, cabAndVendorGroup);
      }
      if (booking.cab && booking.cab.virtual) {
        const phoneNumber = (booking.cab.driver && booking.cab.driver.phoneNumbers[0])
          ? ' (' + booking.cab.driver.phoneNumbers[0] + ')' : '';
        this.virtualCabDriverDetails[booking.bookingId] = booking.cab.driver.name + phoneNumber;
      }
    }
  }

  getDriverName(driver) {
    return driver['name'];
  }


  getDriverValue(driver) {
    return driver['guid'];
  }

  getCabData(event: any){
    if (this.commonService.workflowConfig['showNonCompliantCabs']) {
      this.cabs = event || [];
    } else {
      this.cabs = event ? event.filter((cab: { compliant: any; }) => cab.compliant) : [];
    }
    if (this.virtualCabFeature) {
      this.cabs = event || [];
    } else {
       this.cabs = event ? event.filter((cab: { virtual: any; }) => !cab.virtual) : [];
    }
  }

  getDriverData(event: any){
    if (this.multiDriverFeature) {
      if (this.miscelleneousConfig['showAllDriverList'] === 'true') {
        this.driverList = event;
      }
      else {
        this.driverList = event;
      }
    } else {
      this.driverList = event;
    }

    this.setDriverFormControl();
  }

  getVendorsAndCabsList() {
    this.commonService.assignData().subscribe((data) => {
      this.commonService.fetchConfig().subscribe((res: any) => {
        this.unsortedData = data;
        data.vehicleData.forEach((ele) => {
        this.vendors.push(ele.vendor);
      });
        this.multiDriverFeature = res['etsMultiDriverEnable'];
        this.virtualCabFeature = res['etsVirtualCabEnable'];
        if (this.multiDriverFeature) {
              if (this.miscelleneousConfig['showAllDriverList'] === 'true') {
                data.vehicleData.forEach((ele) => {
                  ele.driver.forEach((driver) => {
                    this.driverList.push(driver);
                  });
                });
              }
            }
        this.commonService.workflowConfig['showNonCompliantCabs'] ?   data.vehicleData.forEach((ele) => {
              ele.cab.forEach((cab) => {
                this.cabs.push(cab);
              });
            }) :  this.cabs = data.vehicleData.forEach((ele) => {
              ele.cab.filter((cab) => {
                return cab.compliant;
              });
            });
        this.virtualCabFeature ? data.vehicleData.forEach((ele) => {
              ele.cab.forEach((cab) => {
                this.cabs.push(cab);
              });
            }) :  data.vehicleData.forEach((ele) => {
              ele.cab.forEach((cab) => {
                if (!cab.virtual) {
                this.cabs.push(cab);
                }
              });
            });
        this.formVendorCabMap();
        this.setDriverFormControl();
        this.offices = data.offices;
        this.getOfficeOptionsEts();
          });

    });
    // this.commonService.getEtsData().subscribe((response) => {
    //   this.commonService.fetchConfig().subscribe((res: any) => {
    //     this.multiDriverFeature = res['etsMultiDriverEnable'];
    //     this.virtualCabFeature = res['etsVirtualCabEnable'];
    //     if (this.multiDriverFeature) {
    //       if (this.miscelleneousConfig['showAllDriverList'] === 'true') {
    //         this.driverList = response['drivers'];
    //       }
    //     }
    //     this.vendors = response.vendors;
    //     this.commonService.workflowConfig['showNonCompliantCabs'] ?   this.cabs = response.cabs : this.cabs = response.cabs.filter((cab) => cab.compliant);
    //     this.virtualCabFeature ? this.cabs = response.cabs :  this.cabs = response.cabs.filter((cab) => !cab.virtual);
    //     this.formVendorCabMap();
    //     this.setDriverFormControl();
    //     this.offices = response.offices;
    //     this.getOfficeOptionsEts();
    //   });
    // });
  }
  formVendorCabMap() {
    for (const vendor of this.vendors) {
      this.vendorCabMap[vendor.guid] = [];
      if (this.cabs){
        for (const cab of this.cabs) {
          if (cab.vendor.guid === vendor.guid) {
            this.vendorCabMap[vendor.guid].push(cab);
          }
        }
      }
    }
  }

  onStartDateChange(dateValue: any) {
    this.startDate = dateValue.next[0];
    this.inputControlStartDate.markAsDirty();
    this.inputControlEndDate.markAsDirty();
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
    }
  }

  setDateFormControlError() {
    // this.inputControlStartDate.setErrors({ incorrectStartDate: true });
    // this.inputControlEndDate.setErrors({ incorrectEndDate: true });
    this.displayInvalidDateError = true;
    this.toggleAutoReload(true);
  }

  removeFormControlError() {
    // this.inputControlEndDate.setErrors(null);
    // this.inputControlStartDate.setErrors(null);
    this.displayInvalidDateError = false;
    this.toggleAutoReload(false);
  }

  onEndDateChange(dateValue: any) {
    this.endDate = dateValue.next[0];
    this.inputControlStartDate.markAsDirty();
    this.inputControlEndDate.markAsDirty();

    if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
    }
  }


  selectedDate(dateValue: any) {
    this.startDate = dateValue.date.startDate ? parseZone(dateValue.date.startDate, 'DD/MM/YYYY') : '';
    this.endDate = dateValue.date.endDate ? parseZone(dateValue.date.endDate, 'DD/MM/YYYY') :  '';
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else  if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else{
      this.removeFormControlError();
      this.isSameDateRange = this.startDate.isSame(this.endDate);
      if(this.isSameDateRange){
        this.formDetails.get('timeRange').setValue({startTime: '00:00', endTime: '23:59'});
      }
      this.handleApplyFilters();
    }

  }
  onSearchInputChange(searchInput: any) {
    this.searchInput = searchInput.value;
    if (this.searchInput && this.searchInput.length > 2) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.searchBookingsCall.bind(this), 500);
    }
    else if (!this.searchInput) {
      this.resetPagination();
      this.getBookingDetails();
    }
  }

  searchBookingsCall() {
    this.resetPagination();
    // Clearing the auto reload bookings timer
    if (this.bookingTimer) {
      clearTimeout(this.bookingTimer);
    }
    this.getBookingDetails();
  }

  onVendorSelected(vendor: any) {
    this.selectedVendor = vendor.vendorInfo;
  }

  getBookingDate(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return dateMoment.format('DD/MM/YY');
    }
    return '';
  }

  getBookingTime(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
        dateMoment.format('hh:mm A') : dateMoment.format('HH:mm');
    }
    return '';
  }

  getBookingActionConfig() {
    this.bookingActionBtnConfig = this.commonService.getConfigForElementKey(this.config, 'Action Buttons');
    this.bookingActionConfig = this.commonService.getConfigForElementKey(this.config, 'Action Ellipsis');
    this.bookingActionBtnConfigObj = {};
    for (const configData of this.bookingActionBtnConfig.elementConfigList) {
      this.bookingActionBtnConfigObj[configData.elementKey] = configData.config;
    }
    for (const configData of this.bookingActionConfig.elementConfigList) {
      this.bookingActionsConfigObj[configData.elementKey] = configData.config;
    }
  }

  setCabAllocConfigs() {
    this.cabAllocationConfig = this.commonService.getConfigForElementKey(this.config, 'Manual Cab Allocation');
    this.cabAllocationConfigObj = {};
    for (const configData of this.cabAllocationConfig.elementConfigList) {
      this.cabAllocationConfigObj[configData.elementKey] = configData.config;
    }
  }

  setTabularConfigs() {
    this.tabularConfig = this.commonService.getConfigForElementKey(this.config, 'Tabular Section');
    for (const configData of this.tabularConfig.elementConfigList) {
      this.tabularConfigObj.set(configData.elementKey, configData.config);
    }
    this.tabularConfigKeys = Array.from(this.tabularConfigObj.keys());    
  }

  setVendorAssignConfig() {
    this.vendorSelectConfigObj = [];
    this.vendorSelectConfig = this.commonService.getConfigForElementKey(this.config, 'Vendor Selection');
    for (const configData of this.vendorSelectConfig.elementConfigList) {
      this.vendorSelectConfigObj[configData.elementKey] = configData.config;
    }
  }

  handleAllBookingsSelected(data: any) {
    this.allBookingsSelected = data.checked;
    const selectedBookingsTemp = [];
    const selectedBookingsDetailedTemp = [];

    if (this.showCheckboxHyphen) {
      this.showCheckboxHyphen = false;
    }
    if (data.checked) {
      for (const booking of this.bookingDetails) {
        if (booking.bookingStatus !== 'CANCELLED') {
          selectedBookingsTemp.push(booking.bookingId);
          selectedBookingsDetailedTemp.push(booking);
        }
      }
      this.selectedBookings = selectedBookingsTemp;
      this.selectedBookingDetailed = selectedBookingsDetailedTemp;
    } else {
      this.setCabAndVendorInitialValues(this.selectedBookings);
      this.selectedBookings = [];
      this.selectedBookingDetailed = [];
    }
  }

  assignIndividual(data: any) {
    if (data) {
      this.selectedBookings.push(data);
      this.handleBookingsSelected({checked: true, value: data});
    }
    clearInterval(this.bookingTimer);
    this.bookingTimer = setTimeout(() => {
      this.isAutoReload = true;
      this.searchInput = "";
      this.getBookingDetails();
    }, 120000);
  }

  handleBookingsSelected(data: any) {
    const selectedBookingsTemp = this.selectedBookings;
    let selectedBookingsDetailedTemp = this.selectedBookingDetailed;
    if (data.checked) {
      selectedBookingsTemp.push(data.value);
      for (const booking of this.bookingDetails) {
        if (booking.bookingId === data.value) {
          selectedBookingsDetailedTemp.push(booking);
          break;
        }
      }
      this.selectedBookings = selectedBookingsTemp;
      this.selectedBookingDetailed = selectedBookingsDetailedTemp;
    } else {
      const index = this.selectedBookings.indexOf(data.value);
      if (index > -1) {
        this.selectedBookings.splice(index, 1);
      }
      selectedBookingsDetailedTemp = this.selectedBookingDetailed.filter((booking) => {
        return booking.bookingId === data.value ? false : true;
      });
      this.selectedBookingDetailed = selectedBookingsDetailedTemp;
      this.setCabAndVendorInitialValues([data.value]);
    }
    this.handleMarkHeaderCheckbox();
  }

  selectVendorAssignedBookings() {
    const newSelectedBookings = [];
    const newSelectedBookingsDetailed = [];
    for (const booking of this.bookingDetails) {
      if (booking.vendor && booking.bookingStatus !== 'CANCELLED') {
        newSelectedBookings.push(booking.bookingId);
        newSelectedBookingsDetailed.push(booking);
      }
    }
    this.selectedBookings = newSelectedBookings;
    this.selectedBookingDetailed = newSelectedBookingsDetailed;
    this.handleMarkHeaderCheckbox();
  }

  selectVendorUnAssignedBookings() {
    const newSelectedBookings = [];
    const newSelectedBookingsDetailed = [];
    for (const booking of this.bookingDetails) {
      if (!booking.vendor && booking.bookingStatus !== 'CANCELLED') {
        newSelectedBookings.push(booking.bookingId);
        newSelectedBookingsDetailed.push(booking);
      }
    }
    this.selectedBookings = newSelectedBookings;
    this.selectedBookingDetailed = newSelectedBookingsDetailed;
    this.handleMarkHeaderCheckbox();
  }

  handleMarkHeaderCheckbox() {
    if (this.selectedBookings.length && this.selectedBookings.length === this.bookingDetails.length) {
      this.allBookingsSelected = true;
      this.showCheckboxHyphen = false;
    } else if (this.selectedBookings.length === 0) {
      this.allBookingsSelected = false;
      this.showCheckboxHyphen = false;
    } else {
      this.allBookingsSelected = false;
      this.showCheckboxHyphen = true;
    }
  }

  isBookingChecked(booking: any) {
    const index = this.selectedBookings.indexOf(booking.id);
    if (index > -1) {
      return true;
    }
    return false;
  }

  showBookingHistory(booking: any) {
    if (booking.bookingId) {
      this.showHistoryView = true;
      this.bookingHistoryId = booking.bookingId;
      this.isSpinning = true;
      this.toggleAutoReload(true);
    }
  }

  handleCloseHistoryView() {
    this.showHistoryView = false;
    this.bookingHistoryId = null;
    this.toggleAutoReload(false);
  }

  onVirtualCabSubmit(event) {
    this.virtualDriver = true;
    this.isSpinning = true;
    const virtualCabDetails = {
      driverName: event.driverName,
      driverPhoneNumber: event.driverPhone,
      cabRegistration: event.driverCabNum
    };
    this.virtualCabDriverDetails[this.virtualCabBooking.bookingId]
      = virtualCabDetails.driverName + " (" + virtualCabDetails.driverPhoneNumber + ")";
    const postData = this.formPostBodyForVendorCabAssign(this.cabs);
    this.subject$.subscribe((resp) => {
      this.getBookingDetails();
    });
    postData[0]['virtualCab'] = virtualCabDetails;
    this.postBulkBookingUpdate(postData, true);
  }

  formPostBodyForVendorCabAssign(cabs: any) {
    const returnInfo = [];
    for (const booking of this.selectedBookingDetailed) {
      const data = {};
      const bookingVendorCabFormGroup = this.vendorCabSelectFormGroup.get(booking.bookingId);
      if(bookingVendorCabFormGroup){
        const cab = bookingVendorCabFormGroup.get('cab').value;
        const vendor = bookingVendorCabFormGroup.get('vendor').value;
        const existingCab = booking.cab ? booking.cab.guId : null;
        const exisingDriver = booking.cab && booking.cab.driver ? booking.cab.driver.guid : null;
        const existingVendor = booking.vendor ? booking.vendor.guid : null;
        this.bookingViewService.clearUpdate.subscribe(res => {
              if (res) { bookingVendorCabFormGroup.get('vendor').reset(); }
        });
        let cabDetails;
        if (this.cabs) {
        cabDetails = this.cabs.find((car) => car.guId === cab);
        }
        // if (this.multiDriverFeature && !cabDetails && this.driverForm[booking.bookingId].get('driver').value) {
        //   return 'noCab';
        // }
        if (cabDetails && !cabDetails.virtual ) {
          // if (!this.driverForm[booking.bookingId].get('driver').value) {
          //   return 'noDriver';
          // } else {
            // if independent list has to be shown

            if (this.miscelleneousConfig['showAllDriverList'] === 'true') {
              const selectedDriver = this.driverList.find((driver) => driver.guid === this.driverForm[booking.bookingId].get('driver').value);
              if (cabDetails.device && selectedDriver.device) {
                data['deviceId'] = this.miscelleneousConfig['inCabDevice'] && this.miscelleneousConfig['inCabDevice'] === 'true'
                  ? cabDetails.device.deviceId : selectedDriver.device.deviceId;
              } else {
                data['deviceId'] = cabDetails.device ? cabDetails.device.deviceId : selectedDriver.device
                  ? selectedDriver.device.deviceId : null;
              }
              data['driverId'] = this.driverForm[booking.bookingId].get('driver').value;
            } else {
              // if dependent list has to be shown

              const selectedDriver = cabDetails.drivers.
                find((driver) => driver.guid === this.driverForm[booking.bookingId].get('driver').value);
              if (cabDetails.device && selectedDriver?.device) {
                data['deviceId'] = this.miscelleneousConfig['inCabDevice'] && this.miscelleneousConfig['inCabDevice'] === 'true'
                  ? cabDetails.device.deviceId : selectedDriver.device.deviceId;
              } else {
                data['deviceId'] = cabDetails.device ? cabDetails.device.deviceId : selectedDriver?.device
                  ? selectedDriver.device.deviceId : null;
              }
              data['driverId'] = this.driverForm[booking.bookingId].get('driver').value;
            }
          // }
        }
        if ((booking.cab && booking.cab.virtual) || cab !== existingCab || vendor !== existingVendor
          || this.driverForm[booking.bookingId].get('driver').value !== exisingDriver) {
          // if (cab) {
          if (cab) {
            data['action'] = 'cab_update';
            data['cabGuid'] = cab;
            data['bookingId'] = booking.bookingId;
            // data['cabAvailRank'] = 'ACTIVE';
            // data['cabAvailRank'] = this.cabRankMap[booking.bookingId];
          } else if (!cab && vendor === existingVendor) {
            data['action'] = 'cab_update';
            data['cabGuid'] = cab;
            data['bookingId'] = booking.bookingId;
          } else if (!cab && vendor !== existingVendor) {
            data['action'] = 'vendor_update';
            data['vendorGuid'] = vendor;
            data['bookingId'] = booking.bookingId;
            data['cabGuid'] = '';
          }
        /*  else if(cab && vendor) {
            data['action'] = 'cab_update';
            data['vendorGuid'] = vendor;
            data['cabGuid'] = cab;
            data['bookingId'] = booking.bookingId;
          } */
          data['modifierGuid'] = this.authService.user.employeeGuid;
          data['modifierBuid'] = this.authService.user.buId;
          returnInfo.push(data);
        }
      }
    }
    this.bookingViewService.clearUpdate.next(false);
    return returnInfo;
  }

  formData(requestInfo: any) {
    const data = {};
    const returnInfo = [];
    data['bookingId'] = requestInfo.bookingId;
    data['modifierGuid'] = this.authService.user.employeeGuid;
    data['modifierBuid'] = this.authService.user.buId;
    data['action'] = requestInfo.action;
    if (requestInfo.action === 'vendor_status_update') {
      data['vendorStatus'] = requestInfo.status;
    } else if (requestInfo.action === 'manager_status_update') {
      data['managerStatus'] = requestInfo.status;
    }
    returnInfo.push(data);
    return returnInfo;
  }

  formPostBodyForStatusUpdate(requestInfo: any) {
    const returnInfo = [];
    for (const bookingId of this.eligibleBookings) {
      const data = {};
      data['bookingId'] = bookingId;
      data['modifierGuid'] = this.authService.user.employeeGuid;
      data['modifierBuid'] = this.authService.user.buId;
      data['action'] = requestInfo.action;
      if (requestInfo.action === 'vendor_status_update') {
        data['vendorStatus'] = requestInfo.status;
      } else if (requestInfo.action === 'manager_status_update') {
        data['managerStatus'] = requestInfo.status;
      }
      returnInfo.push(data);
    }
    return returnInfo;
  }

  handleManagaerAndVendorStatusApproval(data: any) {
    this.isLoading = true;
    let postData;
    postData = this.formData(data);
    if ((data.action === "manager_status_update" && data.status === "REJECTED")) {
      this.showRejectReasonBlock = true;
      this.isLoading = false;
      this.isRejectActionSelected = true;
      this.showModal = true;
      this.rejectPostData = postData;
    } else if (data.action === "vendor_status_update" && data.status === "DENIED") {
      this.showDenyReasonBlock = true;
      this.showModal = true;
      this.showDenyModalVM = true;
      this.isLoading = false;
      this.rejectPostData = postData;
    }
    if (postData.length && !this.isRejectActionSelected && !this.showModal) {
      this.postBulkBookingUpdate(postData);
    }
  }

  getEligibleBookings(key) {
    this.selectedBookingDetailed.forEach((el) => {
      if (el[key]) {
        this.nonEligibleBookings.push(el.bookingId);
      } else {
        this.eligibleBookings.push(el.bookingId);
      }
    });
  }

  handleBookingUpdate(data: any) {
    let postData;
    if (data.action === 'vendor-cab-update') {
      postData = this.formPostBodyForVendorCabAssign(data.cabs);
      if (postData === 'noDriver' || postData === 'noCab') {
        this.showDialog = true;
        this.noDriverOrCab = postData;
        return;
      }
    }

    if (data.status === 'APPROVED') {
      this.getEligibleBookings('Approve-disable');
      postData = this.formPostBodyForStatusUpdate(data);
      this.postDataForApprovaAndAccept = postData;
      this.showApproveModalTM = true;
      this.showModal = true;
    } else if (data.status === 'REJECTED') {
      this.getEligibleBookings('Reject-disable');
      postData = this.formPostBodyForStatusUpdate(data);
      this.isRejectActionSelected = true;
      this.showModal = true;
      this.rejectPostData = postData;
    } else if (data.status === 'ACCEPTED') {
      this.getEligibleBookings('Accept-disable');
      postData = this.formPostBodyForStatusUpdate(data);
      this.postDataForApprovaAndAccept = postData;
      this.showAcceptModalVM = true;
      this.showModal = true;
    } else if (data.status === 'DENIED') {
      this.getEligibleBookings('Deny-disable');
      postData = this.formPostBodyForStatusUpdate(data);
      this.showDenyModalVM = true;
      this.showModal = true;
      this.rejectPostData = postData;
    }
    if (postData.length && !this.isRejectActionSelected
      && !this.showApproveModalTM && !this.showAcceptModalVM
      && !this.showDenyModalVM) {
      this.isLoading = true;
      this.postBulkBookingUpdate(postData);
    } else {
      if (!this.isRejectActionSelected) {
        this.selectedBookings = [];
        this.selectedBookingDetailed = [];
        this.allBookingsSelected = false;
        this.showCheckboxHyphen = false;
        this.isLoading = false;
      }
    }
  }
  postBulkBookingUpdate(postData, fromVirtualCab = false) {
    this.commonService.postBulkBookingUpdate(postData).subscribe((response) => {
      this.replaceUpdatedBookings(response);
      this.isLoading = false;
      this.isSpinning = false;
      if (fromVirtualCab) {
        this.subject$.next(true);
      }
      this.selectedBookings = [];
      this.bookingViewService.setCabRank(null);
      this.cabRankMap = null;
      this.isRejectActionSelected = false;
      this.selectedBookingDetailed = [];
      this.allBookingsSelected = false;
      this.showCheckboxHyphen = false;
      this.isSubmitReasonClicked = false;
      this.showModal = false;
      this.eligibleBookings = [];
      this.nonEligibleBookings = [];
      this.showAcceptModalVM = false;
      this.showApproveModalTM = false;
      this.showDenyModalVM = false;
      this.showDenyReasonBlock = false;
      this.showRejectReasonBlock = false;
      this.showVirtualCab = false;
      this.reasonText = "";
    }, (response) => {
      this.resetCabAndVendorForSelectedBookings();
      this.bookingViewService.setCabRank(null);
      this.cabRankMap = null;
      this.selectedBookings = [];
      this.selectedBookingDetailed = [];
      this.allBookingsSelected = false;
      this.showCheckboxHyphen = false;
      this.isLoading = false;
      this.isSpinning = false;
      this.updateBookingError = true;
      this.isRejectActionSelected = false;
      this.showModal = false;
      this.eligibleBookings = [];
      this.nonEligibleBookings = [];
      this.showAcceptModalVM = false;
      this.showApproveModalTM = false;
      this.showDenyModalVM = false;
      this.showDenyReasonBlock = false;
      this.showRejectReasonBlock = false;
      this.showVirtualCab = false;
      this.updateBookingErrorMessage = response.error.message;
    });
  }

  replaceUpdatedBookings(data: any) {
    const failedBookings = [];

    // form booking map
    const bookingIdMapInfo = {};
    this.bookingDetails.map((booking) => {
      bookingIdMapInfo[booking.bookingId] = booking;
    });

    for (const updatedBooking of data) {
      if (!updatedBooking.cab && this.virtualCabDriverDetails[updatedBooking.bookingId]) {
        this.virtualCabDriverDetails[updatedBooking.bookingId] = "";
      } else if (updatedBooking.cab && updatedBooking.cab.virtual) {
        setTimeout(() => {
          this.vendorCabSelectFormGroup.get(this.virtualCabBooking.bookingId).get('cab').setValue(updatedBooking.cab.registration);
        }, 0);
      } else {
        this.virtualCabDriverDetails[updatedBooking.bookingId] = "";
      }

      if (!updatedBooking.requestId && updatedBooking.otherDetails) {
        failedBookings.push({
          bookingId: updatedBooking.bookingId,
          error: updatedBooking.otherDetails
        });
        this.resetCabAndVendorForSelectedBookings(updatedBooking);
      } else {
        if (updatedBooking && bookingIdMapInfo[updatedBooking.bookingId]) {
          Object.assign(bookingIdMapInfo[updatedBooking.bookingId], updatedBooking);
        }
        const bookingVendorCabFormGroup = this.vendorCabSelectFormGroup.get(updatedBooking.bookingId);
        if (updatedBooking.cab) {
          bookingVendorCabFormGroup.get('cab').setValue(updatedBooking.cab.guId);
        } else {
          bookingVendorCabFormGroup.get('cab').reset();
        }
        if (updatedBooking.vendor) {
          bookingVendorCabFormGroup.get('vendor').setValue(updatedBooking.vendor.guid);
        } else {
          bookingVendorCabFormGroup.get('vendor').reset();
        }
      }
    }
    this.failedBookings = failedBookings;
    this.setBookingAdditionalInfo();
    if (this.failedBookings.length) {
      this.updateBookingError = true;
    } else {
      this.showUpdateSuccess = true;
    }
  }

  replaceMergedBookings(bookingData: any) {
    // form booking map
    const bookingIdMapInfo = {};
    this.bookingDetails.map((booking) => {
      bookingIdMapInfo[booking.bookingId] = booking;
    });

    for (const booking of bookingData) {
      if (bookingIdMapInfo[booking.bookingId]) {
        Object.assign(bookingIdMapInfo[booking.bookingId], booking);
      } else {
        bookingIdMapInfo[booking.bookingId] = {};
        this.bookingDetails.push(booking);
        Object.assign(bookingIdMapInfo[booking.bookingId], booking);
      }
    }
    this.setBookingAdditionalInfo();
    this.sortBookings(this.sortAscending);
    setTimeout(() => {
      this.setVendorAndCabFormControl();
    }, 0);

    this.selectedBookings = [];
    this.selectedBookingDetailed = [];
    this.handleMarkHeaderCheckbox();
    this.successMessage = 'Bookings merged successfully.';
    this.showUpdateSuccess = true;
  }

  resetCabAndVendorForSelectedBookings(bookingData?: any) {
    if (bookingData) {
      this.resetCab(bookingData);
      this.resetVendor(bookingData);
    } else {
      for (const booking of this.selectedBookingDetailed) {
        this.resetCab(booking);
        this.resetVendor(booking);
      }
    }
  }

  resetCab(booking: any) {
    const bookingVendorCabFormGroup = this.vendorCabSelectFormGroup.get(booking.bookingId);
    if (booking.cab) {
      bookingVendorCabFormGroup.get('cab').setValue(booking.cab.guId);
    } else {
      bookingVendorCabFormGroup.get('cab').reset();
    }
  }

  resetVendor(booking: any) {
    const bookingVendorCabFormGroup = this.vendorCabSelectFormGroup.get(booking.bookingId);
    if (booking.vendor) {
      bookingVendorCabFormGroup.get('vendor').setValue(booking.vendor.guid);
    } else {
      bookingVendorCabFormGroup.get('vendor').reset();
    }
  }

  cancelVendorCabUpdateCallBack(booking: any) {
    this.selectedBookings = [];
    this.handleBookingsSelected({checked: false, value: booking.bookingId});
    this.setCabAndVendorInitialValues([booking]);
  }

  setCabAndVendorInitialValues(bookingsUnselected: any[]) {
    for (const bookingToReset of bookingsUnselected) {
      for (const booking of this.bookingDetails) {
        if (booking.bookingId === bookingToReset) {
          const cab = booking.cab ? booking.cab.guId : null;
          const driver = booking.cab ? booking.cab.driver : null;
          const vendor = booking.vendor ? booking.vendor.guid : null;
          this.vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').setValue(this.vendorCabMap[vendor]);
          this.vendorCabSelectFormGroup.get(booking.bookingId).get('vendor').setValue(vendor);
          setTimeout(() => {
            this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').setValue(cab);
          }, 0);
          if (this.multiDriverFeature) {
            if (cab) {
              if (booking.cab.virtual) {
                setTimeout(() => {
                  this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').setValue(booking.cab.registration);
                }, 0);
              }
              const driverDetails = driver;
              this.driverForm[booking['bookingId']].get('driverOption').setValue(this.getDependentDriverList(booking.cab.guId));
              setTimeout(() => {
                this.driverForm[booking['bookingId']].get('driver').setValue(driverDetails && driverDetails.guid);
              }, 0);
            } else {
              this.driverForm[booking['bookingId']].get('driver').reset();
            }
          } else {
            if (cab) {
              if (booking.cab.virtual) {
                setTimeout(() => {
                  this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').setValue(booking.cab.registration);
                }, 0);
              }
            }
          }
          break;
        }
      }
    }
  }


  getCabRegistration(booking: any, driverName?: boolean) {
   if (booking.cab){
      if (this.selectedVirualCabBooking === booking.bookingId) {
        return booking.cab.registration;
      }
      if (driverName && booking.cab.driver && booking.cab.driver.phoneNumbers){
        return booking.cab.driver.phoneNumbers[0] ? booking.cab.driver.name + ' (' + booking.cab.driver.phoneNumbers[0] + ')' : booking.cab.driver.name;
      }
      return booking.cab.registration;
   }
  }

  dismissError() {
    this.showModal = false;
    this.showDialog = false;
    this.isRejectActionSelected = false;
    this.eligibleBookings = [];
    this.nonEligibleBookings = [];
    this.showAcceptModalVM = false;
    this.showApproveModalTM = false;
    this.showDenyModalVM = false;
    this.showDenyReasonBlock = false;
    this.showRejectReasonBlock = false;
    this.updateBookingError = false;
    this.reasonText = "";
    this.failedBookings = [];
    this.isSubmitReasonClicked = false;
  }

  cancelCallback() {
    this.showModal = false;
    this.eligibleBookings = [];
    this.nonEligibleBookings = [];
    this.showAcceptModalVM = false;
    this.showApproveModalTM = false;
    this.showDenyModalVM = false;
    this.showDenyReasonBlock = false;
    this.showRejectReasonBlock = false;
    this.isRejectActionSelected = false;
    this.reasonText = "";
    this.isSubmitReasonClicked = false;
  }

  approveAndAcceptBookings() {
    this.isLoading = true;
    this.postBulkBookingUpdate(this.postDataForApprovaAndAccept);
  }

  submitReasonAndReject() {
    this.isSubmitReasonClicked = true;
    if (this.rejectDenyPopupConfig && this.rejectDenyPopupConfig.config.visibility.visible && this.rejectDenyPopupConfig.config.mandatory) {
      if (this.reasonText && this.reasonText.length <= this.maxLimit) {
        this.isLoading = true;
        this.rejectPostData.forEach((data) => {
          data["reason"] = this.reasonText;
        });
        this.postBulkBookingUpdate(this.rejectPostData);
      }
    } else {
      if (this.reasonText) {
        if (this.reasonText.length <= this.maxLimit) {
          this.isLoading = true;
          this.rejectPostData.forEach((data) => {
            data["reason"] = this.reasonText;
          });
          this.postBulkBookingUpdate(this.rejectPostData);
        }
      } else {
        this.isLoading = true;
        this.rejectPostData.forEach((data) => {
          data["reason"] = "";
        });
        this.postBulkBookingUpdate(this.rejectPostData);
      }
    }
  }

  toggleSuccessToast() {
    this.showUpdateSuccess = false;
    this.successMessage = '';
  }

  toggleLoading(value: any) {
    // this.isLoading = value;
    this.isSpinning = value;
  }

  getOfficeOptionsEts() {
    this.officeOptions = Object.assign([], this.offices);
    this.officeOptions.push({
      address: 'All',
      guid: 'All'
    });
  }

  getOfficeValue(office: any) {
    return office.address;
  }

  getOfficeLabel(office: any) {
    return office.address;
  }

  handleApplyFilters() {
    this.resetPagination();
    this.getBookingDetails();
    this.getBookingsSummaryData();
  }


  showCancelBookingSuccess() {
    this.isSpinning = false;
    this.successMessage = "Booking(s) cancelled successfully";
    this.showUpdateSuccess = true;
    this.getBookingDetails();
    this.getBookingsSummaryData();
  }

  showCancelBookingErrors(data: any) {
    this.isSpinning = false;
    this.updateBookingError = true;
    this.updateBookingErrorMessage = data.error.message;
  }

  sortBookings(sortValue?: any) {
    this.sortAscending = sortValue !== undefined ? sortValue : !this.sortAscending;
    if (this.sortAscending) {
      this.bookingDetails.sort((a, b) => this.utilService.getMoment(a.startTime) - this.utilService.getMoment(b.startTime));
    } else {
      this.bookingDetails.sort((a, b) => this.utilService.getMoment(b.startTime) - this.utilService.getMoment(a.startTime));
    }
  }

  toggleHeader() {
    this.showHeader = !this.showHeader;
  }

  vendorSelectedValidations(booking: any) {
    const vendor = this.vendorCabSelectFormGroup.get(booking.bookingId).get('vendor').value;
    const cab = this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').value;

    let resetCab = true;
    if (vendor) {
      for (const cabInMap of this.vendorCabMap[vendor]) {
        if (cabInMap.guId === cab) {
          resetCab = false;
          break;
        }
      }

      for (const bookingInfo of this.bookingDetails) {
        if (bookingInfo.bookingId === booking.bookingId) {
          this.vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').setValue(this.vendorCabMap[vendor]);
        }
      }
    } else {
      this.vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').setValue(this.cabs);
    }
    if (resetCab) {
      this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').reset();
      this.driverForm[booking.bookingId].get('driver').reset();
    }
    this.selectBookingOnVendorCabAssign(booking);
  }

  cabSelectValidations(booking: any) {
    const vendor = this.vendorCabSelectFormGroup.get(booking.bookingId).get('vendor').value;
    const cab = this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').value;
    let selectedCab;
    if (cab) {
      for (const cabInfo of this.cabs) {
        if (cabInfo.guId === cab) {
          selectedCab = cabInfo;
          if (cabInfo.vendor.guid !== vendor) {
            this.vendorCabSelectFormGroup.get(booking.bookingId).get('vendor').setValue(cabInfo.vendor.guid);
            this.vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').setValue(this.vendorCabMap[cabInfo.vendor.guid]);
          }
          break;
        }
      }
      if (selectedCab && !selectedCab.virtual) {
        this.virtualCabDriverDetails[booking.bookingId] = null;
        if (booking.cab) { booking.cab.virtual = false; }
      }
    }
    if (this.miscelleneousConfig['showAllDriverList'] === 'false') {
      this.selectMultiDriverListForCab(cab, booking.bookingId);
    }
    if (this.virtualCabDriverDetails[booking.bookingId]) {
      this.virtualCabDriverDetails[booking.bookingId] = null;
    }
    this.selectBookingOnVendorCabAssign(booking);
  }

  // to set list of multidrivers in case of multi driver for that particular cab
  selectMultiDriverListForCab(cabGuid, bookingId) {
    const list = this.cabs.find((cab) => cab.guId === cabGuid);
    this.driverForm[bookingId].get('driverOption').setValue(list ? list.drivers : null);
    this.driverForm[bookingId].get('driver').setValue(null);
    if (!cabGuid) {
      this.driverForm[bookingId].get('driverOption').setValue(null);
    }
  }

  // gets called when driver gets selected in the dropdown
 /*  driverChangeCallBack(value, booking) {
    this.cabForselectedDriver = this.cabs.find((cab) => cab.driver.guid === value);
  } */

  driverChangeCallBack(data: any) {
    if (data && data.value && this.driverList && this.driverList.length > 0) {
       const driverData = this.driverList.find((driver) => driver.guid === data.value);
       const phoneNumber = (driverData && driverData.phoneNumbers[0])
       ? ' (' + driverData.phoneNumbers[0] + ')' : '';

       this.virtualCabDriverDetails[data.booking.bookingId] = driverData.name + phoneNumber;
    }
  }


  selectedBookingsVendorValuesReset(vendorGuid: any) {
    for (const booking of this.selectedBookings) {
      this.vendorCabSelectFormGroup?.get(booking)?.get('vendor')?.setValue(vendorGuid);

      const cab = this.vendorCabSelectFormGroup?.get(booking)?.get('cab')?.value;
      let resetCab = true;
      for (const cabInMap of this.vendorCabMap[vendorGuid]) {
        if (cabInMap.guId === cab) {
          resetCab = false;
          break;
        }
      }
      if (resetCab) {
        this.vendorCabSelectFormGroup?.get(booking)?.get('cab')?.reset();
      }

      this.vendorCabSelectFormGroup?.get(booking)?.get('cabOptions')?.setValue(this.vendorCabMap[vendorGuid]);
    }
  }

  selectBookingOnVendorCabAssign(booking: any) {
    if (this.selectedBookings.length) {
      if (!this.isBookingChecked({ id: booking.bookingId })) {
        this.selectedBookings.push(booking.bookingId);
        this.selectedBookingDetailed.push(booking);
      }
    } else {
      this.selectedBookings.push(booking.bookingId);
      this.selectedBookingDetailed.push(booking);
    }

    this.handleMarkHeaderCheckbox();
  }

  getSingleRequestDetails(requestId: any) {
    this.isSpinning = true;
    const searchQuery = {
      requestId
    };
    this.commonBookingService.fetchRequestDetails(searchQuery).subscribe((response) => {
      this.singleRequestDetails = response;
      this.isSpinning = false;
    });
  }

  handleShowSingleBookingDetails(booking: any) {
    // this.showBookingDetails = true;
    this.hasDimmBack = true;

    if (booking) {
      this.singleBookingDetails = booking;
      this.singleReg = booking;
    }
    this.toggleAutoReload(true);

  }

  handleCloseBookingDetails() {
    // this.showBookingDetails = false;
    this.hasDimmBack = false;
    this.toggleAutoReload(false);
  }

  handleShowSingleRequestDetails(requestId: any) {
    this.showRequestDetails = true;
    if (requestId) {
      this.getSingleRequestDetails(requestId);
    }
    this.toggleAutoReload(true);
  }

  handleCloseRequestDetails() {
    this.showRequestDetails = false;
    this.toggleAutoReload(false);
  }

  toggleAddCab(booking: any) {
    this.isAddCabFormVisible = !this.isAddCabFormVisible;
    if (this.isAddCabFormVisible) {
      this.addCabForBooking = booking;
      this.toggleAutoReload(true);
    } else {
      this.toggleAutoReload(false);
    }
  }

  addCabResponse(data: any) {
    this.commonService.etsData = null;
    this.getVendorsAndCabsList();
    if (!data.requestId && data.otherDetails) {
      this.updateBookingError = true;
      this.updateBookingErrorMessage = data.otherDetails;
    } else {
      for (let booking of this.bookingDetails) {
        if (booking.bookingId === data.bookingId) {
          booking = data;
          if (data.vendor) {
            this.vendorCabSelectFormGroup.get(booking.bookingId).get('vendor').setValue(data.vendor.guid);
          }
          if (data.cab) {
            const cabs = this.vendorCabMap[data.vendor.guid];
            let cabExists = false;
            for (const cab of cabs) {
              if (cab.guId === data.cab.guId) {
                cabExists = true;
                break;
              }
            }
            if (!cabExists) {
              this.vendorCabMap[data.vendor.guid].push(data.cab);
            }
            this.vendorCabSelectFormGroup.get(booking.bookingId).get('cabOptions').setValue(this.vendorCabMap[data.vendor.guid]);
            setTimeout(() => {
              this.vendorCabSelectFormGroup.get(booking.bookingId).get('cab').setValue(data.cab.guId);
            }, 0);
          }
          break;
        }
      }
      this.showUpdateSuccess = true;
    }
  }

  toggleAutoReload(pauseAutoReload: boolean) {
    if (pauseAutoReload) {
      if (this.bookingTimer) {
        clearTimeout(this.bookingTimer);
      }
    } else {
      if (this.now >= 120) {
        this.isAutoReload = true;
        this.getBookingDetails();
      } else {
        const time = (120 - this.now) * 1000;
        this.bookingTimer = setTimeout(() => {
          this.isAutoReload = true;
          this.getBookingDetails();
        }, time);
      }
    }
  }

  // Success toaster
  showSuccessToast(message: string) {
    this.successMessage = message;
    this.showUpdateSuccess = true;
  }

  handleDownlodSignInReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY'),
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    const bookingType = this.formDetails ? this.formDetails.get('bookingType').value : ['All'];
    const city = this.formDetails ? this.formDetails.get('city').value : ['All'];
    const office = this.formDetails && this.formDetails.get('office').value
     ? this.formDetails.get('office').value : null;
    const vendorCabStatus = this.formDetails ? this.formDetails.get('vendorCabStatus').value : ['All'];
    const cabTypes = this.formDetails ? this.formDetails.get('cabTypes')?.value : [];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      cabTypes,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid

    };


    this.toggleLoading(true);
    this.bookingActionsHeaderService.downloadSignInReport(searchQuery, postBody).subscribe((response: any) => {
      this.downloadAsCsvService.downloadcsvFile(response);
      this.toggleLoading(false);
    }, (response) => {
      this.toggleLoading(false);
      this.downloadReportFailed = "SignInReport download failed";
    });
  }

  handleDownloadBookingReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY')
    };
    const bookingType = this.formDetails ? this.formDetails.get('bookingType').value : ['All'];
    const city = this.formDetails ? this.formDetails.get('city').value : ['All'];
    const office = this.formDetails && this.formDetails.get('office').value
     ? this.formDetails.get('office').value : null;
    const vendorCabStatus = this.formDetails ? this.formDetails.get('vendorCabStatus').value : ['All'];
    // const marshallStatus = this.formDetails ? this.formDetails.get('marshallStatus').value : ['All'];
    const cabTypes = this.formDetails ? this.formDetails.get('cabTypes')?.value : [];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      cabTypes,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid
      // marshallStatus : marshallStatus
    };

    this.toggleLoading(true);
    this.bookingActionsHeaderService.downloadBookingDetails(searchQuery, postBody).subscribe((response: any) => {
      this.toggleLoading(false);
      this.commonBillingService.downloadBlob(response);
    }, (response) => {
      this.toggleLoading(false);
      this.downloadReportFailed = "Report download failed";
    });
  }

  handleDownloadGenerateReport(newReport?:any) {
   
       const searchQuery = {
          startDate: this.startDate.format('DD-MM-YYYY'),
          endDate: this.endDate.format('DD-MM-YYYY'),
          loggedInEmail : this.authService.user.loginEmpId=='undefined' ? "" : this.authService.user.loginEmpId ,
          newBillingReport : newReport && this.miscelleneousConfig?.newBillingReport ? 'newBillingReport' : ''
         
         
        };
       const bookingType = this.formDetails ? this.formDetails.get('bookingType').value : ['All'];
       const city = this.formDetails ? this.formDetails.get('city').value : ['All'];
       const office = this.formDetails && this.formDetails.get('office').value
         ? this.formDetails.get('office').value : null;
       const vendorCabStatus = this.formDetails ? this.formDetails.get('vendorCabStatus').value : ['All'];
        // const marshallStatus = this.formDetails ? this.formDetails.get('marshallStatus').value : ['All'];
        const cabTypes = this.formDetails ? this.formDetails.get('cabTypes')?.value : [];
       const postBody = {
          bookingType,
          city,
          office,
          status: vendorCabStatus,
          cabTypes,
          buId: this.authService.user.buId,
          clientId: this.authService.client.client,
          employeeGUID: this.authService.user.employeeGuid
          // marshallStatus:marshallStatus
        };

       this.toggleLoading(true);
       this.bookingActionsHeaderService.downloadGenerateReports(searchQuery, postBody).subscribe((response: any) => {
          // this.toggleLoading(false);
          // this.commonBillingService.downloadBlob(response);
          if (response.status == 200){
            this.toggleLoading(false);
            this.requestRaised = "Your Request processed successfully !";
          }
        }, (response) => {
          this.toggleLoading(false);
          this.requestRaised = "Error !";
        });
      }

  hideDownloadReportError() {
    this.downloadReportFailed = '';
  }

  hideGenerateReport() {
     this.requestRaised = '';
  }

  handlePageSizeChange(size: number) {
    this.pageSize = size;
    this.getBookingDetails();
  }

  ceilingPageSize() {
    if(this.pageSize > 0 && this.pageSize <= 80){
      this.pageSize = Math.ceil(this.pageSize / 20) * 20;
    } else if(this.pageSize > 80){
      this.pageSize = 80;
    } else {
      this.pageSize = 20;
    }
  }

getMarshallStatus(status){
  switch (status){
    case 'ALLOCATED':
      return 'Marshall Assigned';
    case 'NOT_NEEDED':
      return 'Marshall Not Requested';
    case 'NOT_REQUIRED_FOR_NOW':
      return 'Marshall Not Required';
    case 'PENDING':
      return 'Marshall Requested';
  }
}

  ngOnDestroy() {
    if (this.bookingTimer) {
      clearTimeout(this.bookingTimer);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  downloadReport(event){
    switch (event.label){
    case "Sign-In Report": this.handleDownlodSignInReport(); break;
    case "Booking Report": this.handleDownloadBookingReport(); break;
    case "Billing Report": this.handleDownloadGenerateReport(); break;
    case "New Billing Report": this.handleDownloadGenerateReport(true); break;
   }
  }

  checkIfMarshalAssigned(booking){
    booking.stops?.forEach(stop => {
      stop.riders?.forEach(rider => {
        rider.riderType === 'MARSHAL' ? this.marshalAssigned = true : this.marshalAssigned = false;
      });
    });
    return this.marshalAssigned == true ? this.marshallAssignedIcon : this.marshallRequestedIcon;
  }

  showMarshallAssignmentToast(event){
    this.showToast = true;
    this.toastMsg = event;
    setTimeout(() => {this.showToast = false; }, 3000);
  }

  getJobTitle(stops){
    let levels=this.miscelleneousConfig?.jobTitleHierarchyList
    let highestTitleIndex = levels.length - 1;
    let highestTitle;
    
    if (stops) {
      stops.forEach(stop => {
        stop.riders.forEach((rider) => {
          if (rider.boardingType === 'PickUp' && rider.riderType !== 'MARSHAL') {
            let titleIndex = levels.indexOf(rider.jobTitle);
            if(titleIndex<0){
              levels.push(rider.jobTitle)
              titleIndex = levels.indexOf(rider.jobTitle);
            } 
            if (titleIndex < highestTitleIndex) {
              highestTitleIndex = titleIndex;
              highestTitle = levels[highestTitleIndex];
            }
          }
        });
      });
    }
    return highestTitle;
  }
  getIcons(booking){

    let iconList=[]
   if(booking.guardReq && booking.escortStatus!=='NOT_REQUIRED_FOR_NOW'){
   iconList.push({
      icon: this.checkIfMarshalAssigned(booking),
      description: this.getMarshallStatus(booking.escortStatus)
    })
   }
   if(booking.reason){
    iconList.push({
      icon: this.commentsIcon,
      description: booking.reason
    })
   }
   if(booking.spotBookingMethod === 'MERGED_TRIP'){
    iconList.push({
      icon: this.mergeBookingIcon,
      description: 'Merged Booking'
    })
   }
   if(this.authService.user.role == 'TRANSPORT_MANAGER' && booking.documentId!=null){
    iconList.push({
      icon: this.documentIcon,
      description: 'Document Attached'
    })
   }
   return iconList
   
   
  }
}

